<!-- 商品发布 - 基础设置 -->
<template>
	<a-form-model ref="formRef" :model="formData" :disabled="isDetail" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
    <a-row :gutter="12">
      <a-col :span="23" :offset="1">
        <a-form-model-item label="商品名称" prop="name">
          <a-input v-model="formData.name" class="w-80!" placeholder="请输入商品名称"/>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :span="9" :offset="1">
        <a-form-model-item label="服务商" prop="facilitatorId">
          <a-select v-model="formData.facilitatorId" @change="changeFacilitator" class="w-80" placeholder="请选择服务商">
            <a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
      <a-col :span="9">
        <a-form-model-item label="商品分类" prop="productCategoryId">
          <a-select v-model="formData.productCategoryId" class="w-80" placeholder="请选择商品分类">
            <a-select-option v-for="(item,index) in categoryList" :value="item.productCategoryId" :key="index">{{item.productCategoryName}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :span="9" :offset="1">
        <a-form-model-item label="商品排序" prop="sort">
          <a-input v-model="formData.sort" class="w-80!" placeholder="请输入商品排序" />
        </a-form-model-item>
      </a-col>
      <a-col :span="9" >
        <a-form-model-item label="虚拟销量" prop="virtualSalesCount">
          <a-input v-model="formData.virtualSalesCount" class="w-80!" placeholder="请输入虚拟销量" />
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :span="9" :offset="1">
        <a-form-model-item label="商品状态" prop="productMallState">
          <a-radio-group v-model="formData.productMallState" class="w-80">
            <a-radio :value="3">上架</a-radio>
            <a-radio :value="2">下架</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-col>
      <a-col :span="9">
        <a-form-model-item label="首页显示" prop="isTop">
          <a-radio-group v-model="formData.isTop" class="w-80">
            <a-radio :value="3">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :span="23" :offset="1">
        <a-form-model-item label="商品简介" prop="introduction">  
          <a-input
            v-model="formData.introduction"
            :auto-size="{ minRows: 2, maxRows: 2 }"
            :allow-clear="true"
            :show-word-limit="true"
            class="w-80!"
            maxlength="128"
            placeholder="请输入商品简介"
            type="textarea"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :span="23" :offset="1">
        <a-form-model-item label="商品封面图" prop="picUrl">
          <UploadImg 
            v-model="formData.picUrl" 
            :limit="1" 
            :fileSize="5" 
            :fileType="['png', 'jpg', 'jpeg']" 
            :isShowTip="true"
            :disabled="isDetail"
            @input="uploadPicUrl"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :span="23" :offset="1">
        <a-form-model-item label="商品轮播图" prop="sliderPicUrls">
          <UploadImg 
            v-model="formData.sliderPicUrls" 
            :limit="5" 
            :fileSize="5" 
            :fileType="['png', 'jpg', 'jpeg']" 
            :isShowTip="true"
            :disabled="isDetail"
            @input="uploadSliderPicUrls"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
	</a-form-model>
</template>
<script>
import { copyValueToTarget } from '@/utils'
import UploadImg from '@/components/ImageUpload'

export default {
  name: 'ProductSpuInfoForm',
  props: {
    propFormData: {
      type: Object,
      default: () => {}
    },
    isDetail: {
      type: Boolean,
      default: false // 是否作为详情组件
    },
    activeKey: {
      type: String,
      default: 'info'
    }
  },
components: {
    UploadImg
},
  data() {
    return {
      formData: {
        name: '', // 商品名称
        facilitatorId: undefined, // 服务商
        productCategoryId: undefined, // 商品分类
        picUrl: '', // 商品封面图
        sliderPicUrls: [], // 商品轮播图
        introduction: '', // 商品简介
        sort: 0, // 商品排序
        virtualSalesCount: 0,// 虚拟销量
        productMallState: 3, // 商品状态 2-下架，3-上架
        isTop:2, // 首页显示状态 3=是，2=否
        
      },
      rules: {
        name: [{ required: true, message: '请输入商品名称', trigger: 'change' }],
        productCategoryId: [{ required: true, message: '请选择商品分类', trigger: 'change' }],
        facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'change' }],
        introduction: [{ required: true, message: '请输入商品简介', trigger: 'change' }],
        picUrl: [{ required: true, message: '请上传商品封面图', trigger: 'change' }],
        sliderPicUrls: [{ required: true, message: '请上传商品轮播图', trigger: 'change' }],
        sort: [{ required: true, message: '请输入商品排序', trigger: 'change' }],
        virtualSalesCount: [{ required: true, message: '请输入虚拟销量', trigger: 'change' }],
        productMallState: [{ required: true, message: '请选择商品状态', trigger: 'change' }],
        isTop: [{ required: true, message: '请选择首页显示状态', trigger: 'change' }],
      },
      categoryList: [], // 商品分类树
      facilitatorList: [], // 服务商列表
    }
  },
  watch: {
    propFormData: {
      handler: function(data) {
        if (!data) {
          return
        }
        copyValueToTarget(this.formData, data)
      },
      immediate: true
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    /** 初始化数据 */
    async initData() {
      // 获取服务商列表
      await this.apiFacilitatorList()
      // 获取分类列表
      await this.apiProductFacilitatorCategoryList()


    },
    //获取服务商列表
    async apiFacilitatorList() {
        try {
            const {
                data: res
            } = await this.$http.post(this.navigation.apiFacilitatorList, {staffId:window.sessionStorage.getItem('staffId')});
            if (res.code == 200) {
                // 确保facilitatorList始终是数组
                this.facilitatorList = Array.isArray(res.data) ? res.data : []
            } else {
                this.$message.error(res.msg)
                this.facilitatorList = []
            }
        } catch (error) {
            console.error('获取服务商列表失败:', error)
            this.$message.error('获取服务商列表失败')
            this.facilitatorList = []
        }
    },
    //服务商改变时，获取分类列表
    changeFacilitator() {
      this.formData.productCategoryId = undefined
      this.apiProductFacilitatorCategoryList()
    },
    //获取分类列表
    async apiProductFacilitatorCategoryList() {
      if (!this.formData.facilitatorId) {
        return
      }
      const {
          data: res
      } = await this.$http.post(this.navigation.apiProductFacilitatorCategoryList,{'facilitatorId':this.formData.facilitatorId});
      if (res.code == 200) {
          // 确保checkstation始终是数组
          this.categoryList = Array.isArray(res.data) ? res.data : []
      } else {
          this.$message.error(res.msg)
          this.categoryList = []
      }

    },
    /** 表单校验 */
    async validate() {
        try {
          await this.$refs.formRef.validate()
          // 校验通过更新数据
          Object.assign(this.propFormData, this.formData)
        } catch (e) {
          this.$message.error('【基础设置】不完善，请填写相关信息')
          this.$emit('update:activeKey', 'info')
          throw e // 目的截断之后的校验
        }
    },
    uploadPicUrl(val) {
        this.formData.picUrl = val
    },
    uploadSliderPicUrls(val) {
      console.log("上传轮播图",val)
        this.formData.sliderPicUrls = val
    },
  }
}
</script>
<style scoped lang="less">

</style>
